__turbopack_context__.v({
  "empty": "BoutiquesList-module-scss-module__EuE9oa__empty",
  "emptyHint": "BoutiquesList-module-scss-module__EuE9oa__emptyHint",
  "emptyTitle": "BoutiquesList-module-scss-module__EuE9oa__emptyTitle",
  "grid": "BoutiquesList-module-scss-module__EuE9oa__grid",
  "gridItem": "BoutiquesList-module-scss-module__EuE9oa__gridItem",
  "results": "BoutiquesList-module-scss-module__EuE9oa__results",
  "section": "BoutiquesList-module-scss-module__EuE9oa__section",
  "visuallyHidden": "BoutiquesList-module-scss-module__EuE9oa__visuallyHidden",
});
